import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { PitstopButton } from 'shared';
import deviceStore from 'stores/Classes/DeviceStore';
import styled from 'styled-components';

const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .ant-input {
    border-radius: 5px 0 0 5px;
  }

  button {
    border-radius: 0 5px 5px 0;
  }
`;

const SearchIssue = ({ onSearch }) => {
  const [searchOn] = useState('All');
  const [searchValue, setSearchValue] = useState('');

  const _onSearch = () => {
    let _searchOnCols;

    switch (searchOn) {
      case 'Issue Name':
        _searchOnCols = ['item', 'action'];
        break;
      default:
        _searchOnCols = [
          'item',
          'status',
          'action',
          'causes',
          'symptoms',
          'category',
          'explanation',
          'description',
        ];
    }

    onSearch({
      searchOn: _searchOnCols,
      searchValue,
    });
  };

  const { device } = deviceStore;

  return (
    <SearchWrapper>
      <Input
        style={{ minWidth: device === 'mobile' ? 'auto' : '400px' }}
        placeholder="Search Issues"
        prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
        allowClear
        onChange={(e) => setSearchValue(e.target.value)}
        onPressEnter={_onSearch}
      />
      <PitstopButton onClick={_onSearch}>Search</PitstopButton>
    </SearchWrapper>
  );
};

SearchIssue.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

export default SearchIssue;
